import getStore from "../store";

export default function getIsImmutableIdFeatureOnForConnectedAccount(): boolean {
    return getStore().IsImmutableIdFeatureOnForConnectedAccount;
}
